// Auto-generated by scripts/generate-registry.mjs from packages/modules/type_c_tile_relief_cup/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const type_c_tile_relief_cup: ModuleSchema = {
  "id": "type_c_tile_relief_cup",
  "uniqueId": "B3D_N53LR",
  "createdAt": "2026-10-28T07:30:27.947Z",
  "updatedAt": "2026-10-28T07:30:27.948Z",
  "label": "Relief Cup",
  "description": "Type C closed wall with evenly distributed surface tile relief.",
  "category": "rattan",
  "tags": [
    "type-c-tile-relief-cup"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Diameter",
      "min": 48,
      "max": 140,
      "default": 72,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Height",
      "min": 24,
      "max": 120,
      "default": 54,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "tileWidthU",
      "label": "Tile Width",
      "min": 1,
      "max": 8,
      "default": 3.2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "tileHeightZ",
      "label": "Tile Height",
      "min": 1,
      "max": 6,
      "default": 2.4,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "visibleReliefHeight",
      "label": "Relief Height",
      "min": 0.2,
      "max": 2,
      "default": 0.8,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "gapAlongU",
      "label": "Perimeter Gap",
      "min": 0.4,
      "max": 4,
      "default": 1.2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "gapAlongZ",
      "label": "Row Gap",
      "min": 0.4,
      "max": 5,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "union_body",
      "label": "Wall and Tile Union",
      "default": "#0f766e",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "relief_cup",
      "label": "Type C Relief Cup",
      "name": "Type C Relief Cup",
      "color": "#0f766e",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "union_body",
          "label": "Wall and Tile Union",
          "name": "Wall and Tile Union",
          "groupId": 0,
          "colorKey": "union_body",
          "defaultColor": "#0f766e",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Type C Relief Cup"
    }
  ]
};
